module.exports = __webpack_public_path__ + "img/2.52115a75.webp";